import { IModel } from "@/@types/models/model";
import { coreFields } from "@/models/helpers/coreFields";
import { commonFields } from "./helpers/commonFields";

const User: IModel = {
  title: "Staze",
  apiPath: "staze",
  forms : {
    "default": {
      fields: ["id", "hgss_projekt_sifra", "hps_broj_staze", "hps_drustvo", "hps_naziv", "vrijeme_min", "duljina_m", "delta_h_m", "hgss_napomena", "hps_napomena" ]
    },
    "overlay": {
      fields: ["hps_broj_staze", "hps_drustvo", "hps_naziv", "vrijeme_min", "duljina_m", "delta_h_m", "hgss_napomena", "hps_napomena" ]
    },
    "hgss_user_on_hgss_data": {
      fields: [
        "id",
        { source: "staza_tip_id", readonly: true},
        { source: "hgss_projekt_sifra", readonly: false},
        { source: "hgss_markacija_status_id", readonly: false},
        { source: "hgss_datum_provjere", readonly: false},
        { source: "hgss_napomena", readonly: false},
        { source: "hps_napomena", type: "text", readonly: true},
        "pocetak",
        "kraj",
        "godina_obnove",
        { source: "duljina_m", type: "text", readonly: true},
        { source: "delta_h_m", type: "text", readonly: true},
        "vrijeme_min",
        "zahtjevno_komentar"
      ]
    },
    "hgss_user_on_hps_data": {
      fields: [
        "id",
        { source: "staza_tip_id", readonly: true},
        { source: "hgss_projekt_sifra", readonly: false },
        { source: "hgss_markacija_status_id", readonly: false },
        { source: "hgss_datum_provjere", readonly: false},
        "hgss_napomena",
        { source: "hps_info_url", readonly: false},
        { source: "hps_napomena", readonly: true},
        { source: "pocetak", readonly: true },
        { source: "kraj", readonly: true },
        { source: "godina_obnove", readonly: true },
        { source: "duljina_m", readonly: true},
        { source: "delta_h_m", readonly: true},
        { source: "vrijeme_min", readonly: true},
        { source: "zahtjevno_komentar", readonly: true}
      ]
    },
    "hps_user_on_hps_data": {
      fields: [
        "id",
        { source: "staza_tip_id", readonly: true},
        { source: "hps_oznaka", readonly: true},
        { source: "hps_broj_staze", readonly: false},
        { source: "hps_drustvo", readonly: true},
        { source: "hps_naziv", readonly: true},
        { source: "hps_info_url", readonly: false},
        { source: "hps_napomena", readonly: false},
        { source: "hgss_napomena", readonly: true },
        { source: "pocetak", readonly: true },
        { source: "kraj", readonly: true },
        { source: "godina_obnove", readonly: true },
        { source: "duljina_m", readonly: true},
        { source: "delta_h_m", readonly: true},
        { source: "vrijeme_min", readonly: true},
        { source: "zahtjevno_komentar", readonly: false}
      ]
    },
    "hps_user_on_hgss_data": {
      fields: [
        "id",
        { source: "staza_tip_id", readonly: true},
        { source: "hps_napomena", readonly: false},
        { source: "hgss_napomena", readonly: true },
        { source: "pocetak", readonly: true},
        { source: "kraj", readonly: true},
        { source: "godina_obnove", readonly: true},
        { source: "duljina_m", readonly: true},
        { source: "delta_h_m", readonly: true},
        { source: "vrijeme_min", readonly: true},
        { source: "zahtjevno_komentar", readonly: true},
      ]
    },
    "infopane_plan": {
      fields: ["hps_broj_staze", "duljina_m", "vrijeme_hhmm", "delta_h_m"]
    },
    "infopane_ostale": {
      fields: [ "duljina_m", "vrijeme_hhmm", "delta_h_m"]
    },
  },
  listViews: {
    "default0": {
      fields: ["id", "hps_broj_staze", "hps_naziv"],
      hidden: ["id"]
    },
    "default": {
      fields: ["id", "hps_broj_staze", "podrucje", "planina", "hps_naziv", "hgss_projekt_sifra", "hps_drustvo", "duljina_m", "delta_h_m", "vrijeme_min", "hgss_markacija_status_id", "hgss_datum_provjere", "owner_organisation", "data_source", "active", ],
      hidden: ["id", "hgss_projekt_sifra", "hgss_markacija_status_id", "hgss_datum_provjere"]
    },
    "report-markacije": {
      fields: ["id", "podrucje", "planina", "hps_naziv", "hgss_projekt_sifra", "hgss_markacija_status_id", "hgss_datum_provjere", "owner_organisation", "data_source", "active" ],
      hidden: ["id", "podrucje", "owner_organisation", "data_source", "active"]
    },
    "exportExcel": {
      fields: ["id", "staza_tip_id", "hps_broj_staze", "hps_drustvo", "hgss_markacija_status_id", "hgss_datum_provjere", "hps_napomena", "hgss_napomena", "hgss_projekt_sifra", "duljina_m", "delta_h_m", "vrijeme_min", "hps_naziv", "podrucje", "planina", "active", "hps_oznaka", "zahtjevno_komentar", "owner_organisation", "data_source", "pocetak", "kraj", "godina_obnove"]
    }
  },
  fields: [
    coreFields.id,
    coreFields.active,
    coreFields.created_on,
    // coreFields.created_by,
    coreFields.modified_on,
    coreFields.modified_by,
    commonFields.hgss_modified_on,
    commonFields.hgss_modified_by,
    commonFields.hps_modified_on,
    commonFields.hps_modified_by,
    commonFields.hgss_zemljovid,
    commonFields.podrucje,
    commonFields.planina,
    {
      title: "hps_broj_staze",
      source: "hps_broj_staze",
      ttoken: "staze.broj_staze",
      type: "text",
      validation: {
        maxLength: 10
      },
      readonly: true
    },
    {
      title: "hps_drustvo",
      source: "hps_drustvo",
      ttoken: "staze.hps_pd",
      type: "text",
      validation: {
        maxLength: 30
      }
    },
    {
      title: "HGSS Datum provjere",
      source: "hgss_datum_provjere",
      ttoken: "staze.datum_provjere",
      type: "date",
      validation: {
        maxDate: 0
      }
    },
    {
      title: "duljina_m",
      source: "duljina_m",
      ttoken: "staze.duljina",
      type: "wholenum",
      suffix: "m",
      readonly: true
    },
    {
      title: "delta_h_m",
      source: "delta_h_m",
      ttoken: "staze.delta_h",
      type: "wholenum",
      suffix: "m",
      readonly: true
    },
    {
      title: "vrijeme_min",
      source: "vrijeme_min",
      ttoken: "staze.vrijeme",
      type: "wholenum",
      suffix: "min",
      // tooltip:"staze.vrijeme_tooltip",
    },
    {
      title: "vrijeme_hhmm",
      source: "vrijeme_hhmm",
      ttoken: "staze.vrijeme",
      type: "text",
      validation: {
        maxLength: 5
      },
      tooltip:"staze.vrijeme_tooltip",
      readonly: true
    },
    {
      title: "Naziv",
      source: "hps_naziv",
      ttoken: "staze.naziv",
      type: "text",
      validation: {
        maxLength: 254
      },
      width: "full"
    },
    {
      title: "hgss_projekt_sifra",
      source: "hgss_projekt_sifra",
      ttoken: "staze.projekt_id",
      type: "text",
      validation: {
        maxLength: 10
      },
      readonly: true
    },
    {
      title: "broj_komentara",
      source: "broj_komentara",
      ttoken: "data.broj_komentara",
      type: "numeric",
      readonly: true
    },
    {
      title: "staza_tip_id",
      source: "staza_tip_id",
      ttoken: "data.staza_tip",
      type: "picker",
      items: {
        labels: ["common.planinarska-staza", "common.ostale-staze", "common.via-ferrata"],
        values: [30, 90, 93]
      },
      translate: true,
      readonly: false
    },
    { 
      title: "pocetak",
      source: "pocetak",
      ttoken: "data.pocetak",
      type: "text",
      readonly: false
    },
    { 
      title: "kraj",
      source: "kraj",
      ttoken: "data.kraj",
      type: "text",
      readonly: false
    },
    { 
      title: "zahtjevno_komentar",
      source: "zahtjevno_komentar",
      ttoken: "data.zahtjevno_komentar",
      type: "text",
      readonly: false,
      width: "full"
    },
    { 
      title: "godina_obnove",
      source: "godina_obnove",
      ttoken: "data.godina_obnove",
      type: "text",
      readonly: false
    },
    {
      title: "hps_napomena",
      source: "hps_napomena",
      ttoken: "staze.hps_napomena",
      type: "text",
      validation: {
        maxLength: 254
      },
      width: "full"
    },
    {
      title: "hgss_napomena",
      source: "hgss_napomena",
      ttoken: "staze.hgss_napomena",
      type: "text",
      validation: {
        maxLength: 254
      },
      width: "full"
    },
    {
      title: "hgss_markacija_status_id",
      source: "hgss_markacija_status_id",
      ttoken: "staze.hgss_markacija_status_id",
      type: "picker",
      items: {
        labels: ['common.nije-markirano', 'common.lose-markirano', 'common.dobro-markirano', 'common.nepoznato'],
        values: [0, 1, 2, 9]
      },
      translate : true,
      readonly: false
    },
    {
      title: "hps_oznaka",
      source: "hps_oznaka",
      ttoken: "staze.hps_oznaka",
      type: "text",
      readonly: false
    },
    {
      title: "HPS info url",
      source: "hps_info_url",
      ttoken: "data.hps_info_url",
      type: "url",
      width: "full",
      readonly: true,
    },
    {
      title: "Zahtjevno ferata",
      source: "zahtjevno_ferata",
      ttoken: "staze.ferata",
      type: "boolean",
      items: {
        labels: ["common.ne", "common.da"],
        values: [false, true]
      },
      readonly: true,
      translate: true
    },
    commonFields.podrucje,
    commonFields.planina,
    commonFields.wkt,
    commonFields.proj,
    commonFields.owner_organisation,
    commonFields.data_source,
    {
      title: "warnings_podrucja",
      source: "warnings_podrucja",
      ttoken: "staze.warnings_podrucja",
      type: "array" 
    },
    {
      title: "warnings_msp",
      source: "warnings_msp",
      ttoken: "staze.warnings_msp",
      type: "array" 
    }
  ]
}

export default User;
